import React from "react";
import styles from "./LaneRow.module.css";
import ReactTooltip from "react-tooltip";

const LaneRow = ({
  lane,
  overrideSelection,
  setOverrideSelection,
  globalSelection,
  index,
}) => {
  const laneKey =
    lane.freight_id ||
    `${lane.origin.location_name}-${lane.destination.location_name}-${lane.truck_type.value}`;
  const selected = overrideSelection[laneKey] || globalSelection;

  const handleToggle = (value) => {
    if (value === "fm" && lane.fm_transporter.length === 0) return; // disable FM if no data
    setOverrideSelection((prev) => ({ ...prev, [laneKey]: value }));
  };

  const uploadedNames =
    lane.shortlisted_transporters.length > 0
      ? lane.shortlisted_transporters.map((t, index) => {
          const rankWithL = t?.rank?.toString().startsWith("L")
            ? t.rank
            : `L${t.rank}`;

          return (
            <div key={index}>
              {rankWithL} - {t.transporter_name}
            </div>
          );
        })
      : "No Transporters";

  const fmNames =
    lane.fm_transporter.length > 0
      ? lane.fm_transporter.map((t, index) => {
          const rankWithL = t?.rank?.toString().startsWith("L")
            ? t.rank
            : `L${t.rank}`;

          return (
            <div key={index}>
              {rankWithL} - {t?.transporter_name}
            </div>
          );
        })
      : "No Transporters";

  return (
    <tr>
      <td style={{ fontSize: "14px" }}>
        <span
          data-tip
          data-for={`lane-tooltip-${index}`}
          style={{ display: "block", textAlign: "left" }}
        >
          <span style={{ fontSize: "14px" }}>
            <span>
              <i className="fa fa-map-marker" style={{ color: "#393186" }} />{" "}
              {lane?.origin?.location?.location}
            </span>{" "}
            →{" "}
            <span>
              <i className="fa fa-map-marker" style={{ color: "#393186" }} />{" "}
              {lane?.destination?.location?.location}
            </span>
          </span>
        </span>

        <div style={{ fontSize: "12px", marginTop: "4px" }}>
          {lane.truck_type.label}
        </div>

        <span
          className={
            lane.exists === "yes" ? styles.badgeExist : styles.badgeNew
          }
          style={{ marginTop: "6px", display: "inline-block" }}
        >
          {lane.exists === "yes" ? "Existing Lane" : "New Lane"}
        </span>

        <ReactTooltip
          id={`lane-tooltip-${index}`}
          place="bottom"
          effect="float"
          backgroundColor="#393185"
        >
          Origin: {lane.origin.location_name}
          <br />
          Destination: {lane.destination.location_name}
          <br />
          Truck Type: {lane.truck_type.label}
        </ReactTooltip>
      </td>
      <td>
        <div className={styles.toggleGroup}>
          <div
            className={`${styles.toggleButton} ${
              selected === "uploaded" ? styles.active : ""
            } d-flex align-items-center`}
            onClick={() => handleToggle("uploaded")}
          >
            <input
              type="radio"
              className="mr-3 m-0"
              checked={selected === "uploaded"}
              onChange={() => handleToggle("uploaded")}
            />
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                textAlign: "left",
              }}
            >
              {uploadedNames}
            </div>
          </div>
        </div>
      </td>
      <td>
        <div className={styles.toggleGroup}>
          <div
            className={`${styles.toggleButton} ${
              selected === "fm" ? styles.active : ""
            } ${
              lane.fm_transporter.length === 0 ? styles.disabled : ""
            } d-flex align-items-center`}
            onClick={() => handleToggle("fm")}
          >
            <input
              type="radio"
              className="mr-3 m-0"
              checked={selected === "fm"}
              onChange={() => handleToggle("fm")}
            />
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                textAlign: "left",
              }}
            >
              {fmNames}
            </div>
          </div>
        </div>
      </td>
    </tr>
  );
};

export default LaneRow;
